export default __webpack_public_path__ + "static/media/wanna5.62429651.png";